import BaseMode from './BaseMode';
import Effect from '../Effect/EffectLine';
import Layer from '../Layer/CircleModeLayer';
import { DEFAULT_CIRCLE_OPTION } from '../../renderOption';
import { FUN_TYPE, EFFECT_TAG, LAMP_LAYOUT_SERVICE_MODE, CIRCLE_LAYOUT_SERVICE_MODE } from '../../enums/index';
import { fixedNumber } from '../../utils/common';
import { getSingleLineSizeWithAngle } from '../../utils/line'; 

/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    config: {},
    rendrenOption: {},
    content: null,
    stage: null,
    canvasContent: null,
    curDrawLayerId: 0,
    drawLayer: new Map(),
    stageSize: { with: 0, height: 0 },
    curCircleCenter: {
      startX: 0,
      startY: 0
    },
    isCircleDrawing: false, // 是否在绘制圆形过程
  };
}

/**
 * 直角线绘制组件
 */
class LineMode extends BaseMode {
  constructor(props) {
    super(props);

    this.init(props);
  }

  data = getDefaultData();

  init = (props = {}) => {
    this.initProps(props);

    this.data.rendrenOption = this.mergeDrawOption(
      props.rendrenOption,
      DEFAULT_CIRCLE_OPTION
    );

    if (!props.initData) {
      // 首次创建
      this.createDrawLayer(props.stageMapId || 0);
    } else {
      // 根据储存数据回显
      this.revertDrawLayer(props);
    }

    // 注册事件
    this.registerDrawPointer();
  }

    // 恢复回显数据 用于保存过历史数据
    revertDrawLayer(props) {
      const initData = props.initData;
      const activeId = props.stageMapId || 0;
      const historyBgSize = props.historyBgSize;
      const bgSize = props.bgSize;
      // const historyStageSize = props.historyStageSize;
      // const stageSize = props.stageSize;

      let ratio = 1;


      if (historyBgSize && historyBgSize.width) {
        ratio = Number((bgSize.width / historyBgSize.width).toFixed(2));
      }
      console.log('ratio ratio', ratio);
      Object.entries(initData).forEach(([ id, drawLayerData = {} ]) => {
        const {
          c: circleRenderData = {},
          l: lampRenderData = {}
        } = drawLayerData;
  
        // 创建挂载物图层 false不直接切当前图层【 阻止直接做渲染 】
        this.createDrawLayer(id, false);
  
        // 切到当前图层
        this.data.curDrawLayerId = id;
  
        const { m: circleMode, d: circleData } = circleRenderData;
        const { m: lampMode, dl: lampList, c: lampCount } = lampRenderData;
  
        if (
          circleMode === CIRCLE_LAYOUT_SERVICE_MODE.SIMPLE &&
          circleData
        ) {
          const renderData = circleData.r
          this.createCircleDevice(renderData.x * ratio, renderData.y * ratio, renderData.radius * ratio);
        }
  
        // 平均模式 直接按线均值切分灯
        if (
          lampMode === LAMP_LAYOUT_SERVICE_MODE.AVERAGE &&
          lampCount !== 0 &&
          Number.isInteger(lampCount)
        ) {
          this.addLamp(lampCount, false);
        }
      });
  
      // curDrawLayerId不变化的话不会触发render高亮
      this.data.curDrawLayerId = -1;
  
      // 激活首个图层 将其余的变暗淡
      this.setCurLineLayerIndexWithAllOpacity(activeId);
      
      // 对所有挂载物进行一次性渲染
      this.renderAllLayer();
    }

  /**
   * 创建新的挂载物
   * @param {*} mapId 
   * @param {*} isSetCurLineLayer 
   */
  createDrawLayer(mapId, isSetCurLineLayer = true) { 
    // Layer {
    //   外圈圆
    //   circleNode: new window.Konva.Circle({}),
    //   内圈圆
    //   circlePointerNode: new window.Konva.Circle({}),
    //   双向链表形式 灯 -> 灯
    //   lampNodeQueue: new CircleNodeQueue({
    //     render: this.render
    //   }),
    // };
    
    const drawLayer = new Layer({
      stage: this.data.stage,
      mapId,
      index: this.data.drawLayer.size
    });

    this.data.drawLayer.set(mapId, drawLayer)
    this.data.stage.add(drawLayer.stateNode);

    if (isSetCurLineLayer && mapId !== 0) this.setCurLineLayerIndex(mapId);

    this.addTrackedEventListener(drawLayer.stateNode, 'click', () => {
      this.setCurLineLayerIndex(mapId);

      if (this.data && this.data.onActive) this.data.onActive(mapId);
    })

    return drawLayer;
  }

  // 创建新的圆形灯带
  createCircleDevice (x, y, radius) {
    const drawLayer = this.getCurDrawLayer(); // 当前图层
    const insertPointer = this.createCircle({
      x,
      y
    }, FUN_TYPE.POINTER, this.data.rendrenOption.pointer);

    const insertCircle = this.createCircle({
      radius: radius || this.data.rendrenOption.pointer.radius + 1 || 5,
      x,
      y
    }, FUN_TYPE.CIRCLE, this.data.rendrenOption.circle);

    drawLayer.add(insertPointer);
    drawLayer.add(insertCircle);
    drawLayer.setCircleNode(insertPointer, insertCircle);

    this.addTrackedEventListener(
      insertCircle.stateNode,
      'mousedown',
      (e) => this.handlerMoveStart(insertCircle, e)
    );
  }

  // 注册图层点击事件 绘制圆圈
  registerDrawPointer() {
    // 使用追踪的事件监听器
    this.addTrackedEventListener(this.data.canvasContent, 'mousedown', (e) => {
      if (e && e.which !== 1) {
        this.data.btnInstance && this.data.btnInstance.setIsCanDraw(false);
        return;
      }
        
      // 结束绘制路径后不允许绘制
      if (!this.data.btnInstance.getData().isCanDraw) return;
      // 新增点和连线
      this.startNewCircleDevice(e);
    });
  
    this.addTrackedEventListener(this.data.canvasContent, 'mousemove', (e) => {
      // 结束绘制路径后不允许绘制
      if (
        !this.data.btnInstance.getData().isCanDraw &&
        !this.data.btnInstance.getData().isCanEdit ||
        !this.data.isCircleDrawing
      ) return;
  
      const drawLayer = this.getCurDrawLayer();
  
      // 新增点和连线
      this.paddingNewCircleDevice(e, false);
      this.addLamp(drawLayer.lampNodeQueue.count);
    });
  
    this.addTrackedEventListener(this.data.canvasContent, 'mouseup', (e) => {
      this.endNewCircleDevice(e);
    });
  }

  // 新增圆心起始
  startNewCircleDevice(e) {
    const drawLayer = this.getCurDrawLayer(); // 当前图层
    const { offsetX, offsetY } = e || {};

    // 更新
    if (!!drawLayer.circleNode) {
      this.deleteAllLine();
    }

    this.data.curCircleCenter = {
      x: offsetX,
      y: offsetY
    };

    this.data.isCircleDrawing = true;

    this.createCircleDevice(offsetX, offsetY);
    drawLayer.render();
  }

  // 拖动圆的半径
  paddingNewCircleDevice(e, isRender = true) {
    const drawLayer = this.getCurDrawLayer(); // 当前图层
    const { offsetX, offsetY } = e || {};
    const { x: startX, y: startY } = this.data.curCircleCenter;

    // 半径
    const radius = getSingleLineSizeWithAngle(startX, startY, offsetX, offsetY);

    // 更新
    if (drawLayer.circleNode) {
      drawLayer.circleNode.flags |= EFFECT_TAG.RADIUS;
      drawLayer.circleNode.effects.push({
        flag: EFFECT_TAG.RADIUS,
        payload: {
          radius: fixedNumber(radius)
        }
      });

      drawLayer.circleNode.flushEffects();
      
      isRender && drawLayer.render();

      return;
    }
  }

  // 结束创建圆的过程
  endNewCircleDevice() {
    const drawLayer = this.getCurDrawLayer(); // 当前图层
    this.data.curCircleCenter = {
      x: 0,
      y: 0
    };

    this.data.isCircleDrawing = false;
    
    if (drawLayer.circleNode && drawLayer.circleNode.renderData.radius < 10) {
      this.deleteAllLine();
    }
  }

  // 删除所有线
  deleteAllLine = () => {
    const drawLayer = this.getCurDrawLayer();
    const { circleNode, circlePointerNode } = drawLayer;

    circleNode.flags |= EFFECT_TAG.DELETE;
    circlePointerNode.flags |= EFFECT_TAG.DELETE;

    circleNode.flushEffects();
    circlePointerNode.flushEffects();

    drawLayer.clearCircleNode();
    // 批量删除所有灯 并且渲染
    this.clearLampNodeQueue(true);
  }

  // 更新灯数据
  calLampEffectTagList = () => {
    const drawLayer = this.getCurDrawLayer();
    const { lampNodeQueue } = drawLayer;
    
    const lampXyByCurLayer = this.getLampXyByCurLayer(lampNodeQueue.count); // 获取灯的位置

    let curNode = lampNodeQueue.firstNode;
    let curIndex = 0;

    while (curNode) {
      const curData = lampXyByCurLayer[curIndex] || {};

      curNode.flags |= EFFECT_TAG.POSITION;
      curNode.effects.push(new Effect({
        flag: EFFECT_TAG.POSITION,
        payload: {
          x: curData.x,
          y: curData.y
        }
      }));

      curIndex++;
      curNode = curNode.next;
    }
  }

  // 获取每个灯的点位
  getLampXyByCurLayer = (count) => {
    const { circleNode } = this.getCurDrawLayer();
    const lampCount = Number(count);

    if (!circleNode) return [];

    const singleAngle = fixedNumber(360 / lampCount);
    const { renderData } = circleNode;
    const { x: cx, y: cy, radius } = renderData;

    let lampData = null;
    let lastData = null;

    for (let i = 0; i < lampCount; i++) {
      const curAngle = singleAngle * i;
      const r = curAngle * Math.PI / 180
      const x = Math.sin(r) * radius;
      const y = Math.cos(r) * radius;
      const curData = {
        x: cx + x,
        y: cy + y
      };

      if (i === 0) {
        lampData = curData;
      } else if (!!lastData) {
        lastData.next = curData;
      }
      
      lastData = curData;
    }

    return lampData;
  }

  // 处理点击节点后拖动前置工作
  handlerMoveStart (curCircle, e) {    
    // 不允许编辑
    if (!this.data.btnInstance.getData().isCanEdit) return;

    const { renderData } =  curCircle;


    this.data.curCircleCenter = { x: renderData.x, y: renderData.y };
    // this.paddingNewCircleDevice(e);

  //   const position = curPointer.renderData;

  //   this.data.curMovePointer.startX = position.x;
  //   this.data.curMovePointer.offsetY = position.y;
  //   this.data.curMovePointer.node = curPointer;

  //   // 获取前后节点
  //   const { prePointer, nextPointer } = this.getEffectNodeList(curPointer);

  //   // 在node上缓存节点当前位置信息
  //   if (prePointer) prePointer.renderData.startMovePosition = prePointer.renderData;
  //   if (nextPointer) nextPointer.renderData.startMovePosition = nextPointer.renderData;

    // 可以进行拖动了
    this.data.isCircleDrawing = true;
  }

  // 拖动过程处理
  handlerPointerMove = (e) => {
    // 不允许编辑
    if (!this.data.btnInstance.getData().isCanEdit) return;
    
  }

  // 拖动结束 stage 和 点 mouseup 都会触发
  handlerPointerMoveEnd = (e) => {
    // 不允许编辑
    if (!this.data.btnInstance.getData().isCanEdit) return;

    // 最后一次对齐节点位置
    this.handlerPointerMove(e);
    
    // 不可以进行拖动
    this.data.isPointerMove = false;
  }

  // 获取所有灯位数据
  getAllLampPosition(mapId) {
    const drawLayer = this.getCurDrawLayer(mapId);
    const { lampNodeQueue } = drawLayer;

    const lampPositionList = [];
    
    let curNode = lampNodeQueue.firstNode;

    while (curNode) {
      lampPositionList.push({
        x: curNode.renderData.x,
        y: curNode.renderData.y,
      });

      curNode = curNode.next;
    }

    return lampPositionList;
  }

  // 创建随机 { mapIds.length } 条线 y为中间值
  createRandomCircle(mapIds = []) {
    const lastId = this.data.curDrawLayerId;
    const { bgSize } = this.data

    mapIds.forEach(item => {
      const { mapId } = item;

      this.setCurLineLayerIndex(mapId);

      const maxSize = Math.min(bgSize.width, bgSize.height);

      const cx = fixedNumber(bgSize.width / 2);
      const cy = fixedNumber(bgSize.height / 2);
      const radius = fixedNumber(Math.random() * maxSize / 2);

      this.createCircleDevice(cx, cy, radius);
    })

    this.setCurLineLayerIndex(lastId);
  }

  // 均分所有线圈
  divideEqually() {
    const { circle, pointer } = this.data.rendrenOption;
    const { strokeWidth } = circle;
    const { radius: pointerRadius } = pointer;
    const { drawLayer, bgSize } = this.data;
    const maxSize = Math.min(
      bgSize.width - strokeWidth / 2 - pointerRadius * 2,
      bgSize.height - strokeWidth / 2 - pointerRadius * 2
    );
    const singleRadius = maxSize / drawLayer.size / 2;

    this.data.drawLayer.forEach((layer, index) => {
      layer.circleNode.flags |= EFFECT_TAG.RADIUS;
      layer.circleNode.effects.push({
        flag: EFFECT_TAG.RADIUS,
        payload: {
          radius: fixedNumber(singleRadius * (layer.index + 1))
        }
      });

      layer.circleNode.flushEffects(false);
    });

    this.renderAllLayer();
  }

  // 获取保存的数据 用于上传服务端
  // 此处由于以字符串形式储存 所以为节约落库表的字段名以精简为主
  // 此处只储存点的数据 并不记录线和灯的坐标 服务下发后 根据mode恢复
  getSaveData = () => {
    const drawLayerData = {};

    this.data.drawLayer.forEach((drawLayer, id) => {
      const circleNode = drawLayer.circleNode || {};

      const data = {
        // circleData
        c: {
          // data
          d: {
            // shapType
            s: circleNode.shapeType,
            // funType
            f: circleNode.funType,
            // renderData
            r: circleNode.getSaveRenderData() || {}
          },
          // mode
          m: CIRCLE_LAYOUT_SERVICE_MODE.SIMPLE
        },
        // lampRenderDataQueue
        l: {
          // mode
          m: LAMP_LAYOUT_SERVICE_MODE.AVERAGE,
          // 数量
          c: drawLayer.lampNodeQueue.count
        }
      }

      drawLayerData[id] = data;
    });

    return drawLayerData;
  }
}

export default LineMode;